(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("editorx-header-and-footer", [], factory);
	else if(typeof exports === 'object')
		exports["editorx-header-and-footer"] = factory();
	else
		root["editorx-header-and-footer"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 